import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { set } from 'lodash';
import { get } from 'lodash';
import { DateHandler } from '../../../../../../shared/utils/DateHandler';

@Component({
  selector: 'gen-normal-specimen',
  templateUrl: './normal-specimen.component.html',
  styleUrls: ['./normal-specimen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NormalSpecimenComponent implements OnInit {
  @Input() sample: any;
  @Input() allowedit: boolean;
  @Input() disabledForced: boolean;
  @Output() callback: EventEmitter<any> = new EventEmitter();
  @Input() index: number;
  @Input() updatedFields: string[];
  public previousValue: any;
  public collectionsData: any;
  private selectedDatepicker: any;

  public tumorChanged: any;
  @Input('collections')
  set collections(specimen) {
    this.collectionsData = specimen ? specimen : { specimenTypes: []};
  }

  constructor() {
  }

  ngOnInit() {
  }

  compareBy(a: any, b: any) {
    return a && b ? a.code === b.code : a === b;
  }

  public resetValue(name) {
    set(this.sample, name, this.previousValue);
  }

  modelChange($event, sample, field, required) {
    if (!required || (required && get(sample, field))) {
      this.callback.emit({ sample, field});
    }
    if ($event.target) {
      $event.target.dispatchEvent(new CustomEvent('deepBlur', { bubbles: true}));
    }
  }

  setTime(date: Date) {
    if (!(date instanceof Date)) { return; }
    date.setHours(12, 0);
    date.setTime(DateHandler.removeTimezone(date).getTime());
  }

  onDateSelect(sample, field) {
    this.callback.emit({sample, field});
    if (this.selectedDatepicker && this.selectedDatepicker !== null) {
      this.selectedDatepicker.focus();
      this.selectedDatepicker.blur();
    }
    this.selectedDatepicker = null;
  }

  onFocus($event) {
    this.selectedDatepicker = $event.target.parentElement.parentElement;
  }

  isInUpdatedFields(field: string) {
    return this.updatedFields && this.updatedFields.indexOf(field) > -1;
  }

  trackByFn(item, index) {
      return item ? item.code : index;
  }

}
